import { AlarmWithUserAlarm } from 'src/models/alarm';

export interface AlarmStateInterface {
	alarms: Array<AlarmWithUserAlarm>;
}

function state(): AlarmStateInterface {
	return {
		alarms: [],
	};
}

export default state;
